import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/shape_circle.svg")